<template>
	<div>
		<el-select
			v-model="value"
			filterable
			placeholder="请选择"
			@change="handleChange"
			style="width: 100%;"

		>
			<el-option
				:label="item.label"
				:value="item.value"
				v-for="item in subDeptList"
				:key="item.value"
			></el-option>
		</el-select>
	</div>
</template>

<script>
import {
	queryPrintdeptApi, //根据组织获取项目部一级数据下拉列表
} from "@/services/sysSettingService";

export default {
	name: "deptSelectComponent",
	props: {
		value: {
			type: String | Number,
		},
		placeholderName: {
			type: String,
		},
	},
	data() {
		return {
			subDeptList: [], //部门列表
		};
	},
	mounted() {
		this.getProjectClubList(); //获取部门一级下拉列表
	},
	methods: {
		//部门数据改变时更新数据
		handleChange(value) {
			let data = {
				value: "",
				label: "",
			};
			if (value) {
				const obj = this.subDeptList.find((i) => (i.value === value));
				data = {
					value: obj.value,
					label: obj.label,
				};
			}
			this.$emit("handleSave", data);
		},
		getProjectClubList() {
			queryPrintdeptApi().then(
				(res) => {
					if (res.code == 10000000) {
						this.subDeptList = res.data.map((item) => {
							return {
								label: item.value,
								value: item.label,
							};
						});
					} else {
						this.$alert(res.msg, "提示", {
							confirmButtonText: "确定",
						});
					}
				},
				(err) => {
					this.$alert("系统异常", "提示", {
						confirmButtonText: "确定",
					});
				}
			);
		},
	},
};
</script>

<style scoped></style>
